import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-warn',
  templateUrl: './message-warn.component.html',
  styleUrls: ['./message-warn.component.scss']
})
export class MessageWarnComponent {
  navigate() {
    window.open('https://yacare.com/preguntas-frecuentes-comercios#2fa', '_blank');
  }
}
